import { render, staticRenderFns } from "./OtherAccountForm.vue?vue&type=template&id=43a1971f&"
import script from "./OtherAccountForm.vue?vue&type=script&lang=ts&"
export * from "./OtherAccountForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports